import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface PageEvent {
  loading: boolean;
  pageSize: number;
  pageRanger: Array<number>;
  startCursor: string;
  endCursor: string;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  back: boolean;
  forward: boolean;
}

@Component({
  selector: 'app-pipe-pagination',
  templateUrl: './pipe-pagination.component.html',
  styleUrls: ['./pipe-pagination.component.scss']
})
export class PipePaginationComponent implements OnInit {
  @Input() loading: boolean;
  @Input() pageSize: number;
  @Input() pageRanger: Array<number>;
  @Input() startCursor: string;
  @Input() endCursor: string;
  @Input() hasNextPage: boolean;
  @Input() hasPreviousPage: boolean;
  @Output() readonly pageEvent = new EventEmitter<PageEvent>();
  private back: boolean;
  private forward: boolean;
  private page = 0;

  constructor() { }

  ngOnInit(): void {
  }

  changePageSize() {
    this.page = 1;
    this.pageEvent.emit(this.getPageEvent());
  }

  pageBack(before?: string) {
    this.decrementPage();
    this.pageEvent.emit(this.getPageEvent());
  }

  pageNext(after?: string) {
    this.incrementPage();
    this.pageEvent.emit(this.getPageEvent());
  }

  get pageNumber() {
    return this.page;
  }

  private decrementPage() {
    this.page--;
    this.back = true;
    this.forward = false;
  }

  private incrementPage() {
    this.page++;
    this.back = false;
    this.forward = true;
  }

  private getPageEvent(): PageEvent {
    return {
      loading: this.loading,
      pageSize: this.pageSize,
      pageRanger: this.pageRanger,
      startCursor: this.startCursor,
      endCursor: this.endCursor,
      hasNextPage: this.hasNextPage,
      hasPreviousPage: this.hasPreviousPage,
      back: this.back,
      forward: this.forward
    };
  }
}
